import { fulfilled, pending, rejected } from '../../../utils';
import { HOUSE_CATEGORY } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	message: '',
	data: '',
	error: '',
};

const houseCategoryReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(HOUSE_CATEGORY):
			return {
				...state,
				loading: true,
				message: '',
				error: '',
			};
		case fulfilled(HOUSE_CATEGORY):
			return {
				...state,
				loading: false,
				status: action.payload.data.status,
				message: action.payload.data.message,
				data: action.payload.data.data,
				error: '',
			};
		case rejected(HOUSE_CATEGORY):
			return {
				...state,
				loading: false,
				message: '',
				error: status ===500 ? "Something went wrong. Please try again later" : action?.payload?.response.data.message,
			};
		default:
			return state;
	}
};

export default houseCategoryReducer;
